module.exports = __webpack_public_path__ + "static/bamboo-d26f4bf94e6be20ac3e12a4351e6c0a3.png";